(function () {
  if (window.__jcCartDrawerFixesLoaded) return;
  window.__jcCartDrawerFixesLoaded = true;

  const SELECTOR = '[data-jc-cart-upsell-add="true"]';

  function setLoading(button, loading) {
    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    const spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.style.display = loading ? '' : 'none';
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSections(cartDrawer) {
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return [];
    try {
      return cartDrawer.getSectionsToRender().map((section) => section.id).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  async function refreshDrawerFallback() {
    const current = getCartDrawer();
    if (!current) return;

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const separator = root.includes('?') ? '&' : '?';
    const response = await fetch(`${root}${separator}section_id=cart-drawer`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Unable to refresh cart drawer');

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const next = documentFragment.querySelector('cart-drawer');
    if (!next) throw new Error('Cart drawer section was not returned');

    const wasOpen = current.classList.contains('active') || current.hasAttribute('open');
    current.innerHTML = next.innerHTML;
    current.className = next.className;
    current.classList.remove('is-empty');

    if (wasOpen && typeof current.open === 'function') {
      current.open();
    } else {
      current.classList.add('active');
    }
  }

  async function addUpsell(button) {
    const formId = button.dataset.jcFormId || button.getAttribute('form');
    const form = formId ? document.getElementById(formId) : button.closest('form');
    if (!form) throw new Error('Upsell product form was not found');

    const formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');

    const cartDrawer = getCartDrawer();
    const sections = getSections(cartDrawer);
    if (sections.length) {
      formData.set('sections', sections.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const endpoint = window.routes && window.routes.cart_add_url
      ? window.routes.cart_add_url
      : '/cart/add.js';

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    const state = await response.json();
    if (!response.ok || state.status) {
      throw new Error(state.description || state.message || 'Unable to add this product');
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state.sections) {
      cartDrawer.renderContents(state);
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
      return;
    }

    await refreshDrawerFallback();
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    setLoading(button, true);
    try {
      await addUpsell(button);
    } catch (error) {
      console.error('[JC cart upsell]', error);
      setLoading(button, false);
      const original = button.querySelector('span');
      if (original) {
        const previous = original.textContent;
        original.textContent = 'Try again';
        window.setTimeout(() => { original.textContent = previous; }, 1800);
      }
    }
  }, true);
})();

/* ==========================================================================
   JC — Cart loader
   ========================================================================== */
(function () {
  var loadingStartSubtotal = null;
  var loadingMaxTimer      = null;
  var loadingUpdateTimer   = null;

  function setCartLoading(on) {
    var cart = document.querySelector('.cart-drawer') || document.querySelector('cart-drawer');
    if (!cart) return;
    clearTimeout(loadingMaxTimer);
    if (on) {
      var items = document.querySelector('cart-drawer-items');
      loadingStartSubtotal = items ? items.dataset.subtotal : null;
      loadingMaxTimer = setTimeout(function () { setCartLoading(false); }, 10000);
    } else {
      loadingStartSubtotal = null;
    }
    cart.classList.toggle('jc-cart-updating', !!on);
  }

  function maybeStopLoading() {
    if (loadingStartSubtotal === null) { setCartLoading(false); return; }
    var items   = document.querySelector('cart-drawer-items');
    var current = items ? items.dataset.subtotal : null;
    if (current !== loadingStartSubtotal) setCartLoading(false);
  }

  function schedule() {
    clearTimeout(loadingUpdateTimer);
    loadingUpdateTimer = setTimeout(maybeStopLoading, 200);
  }

  /* ── watch for cart re-renders ── */
  (function () {
    var target = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(function () { schedule(); }).observe(target, { childList: true, subtree: true });
  })();

  /* ── start loader when any upsell add / cart update begins ── */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-jc-cart-upsell-add="true"], .upsell-toggle-btn, cart-drawer-upsell button');
    if (btn) setCartLoading(true);
  }, true);

  /* ── preselect fix: if toggle is ON but insurance not in cart, add it ── */
  var INSURANCE_HANDLES = ['shipping-insurance', 'shipping-insurance-1'];
  var preSelectDone = false;

  function runPreSelectFix() {
    if (preSelectDone) return;
    var upsell = Array.from(document.querySelectorAll('cart-drawer-upsell'))
      .find(function (el) { return INSURANCE_HANDLES.includes(el.dataset.handle || ''); });
    if (!upsell) return;

    var isOn = upsell.dataset.selected === 'true' || upsell.classList.contains('selected');
    if (!isOn) return;

    preSelectDone = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasInsurance = cart.items.some(function (i) { return INSURANCE_HANDLES.includes(i.handle); });
        if (hasInsurance) return;

        var variantId = Number(upsell.dataset.id);
        if (!variantId) return;

        var cartDrawer = document.querySelector('cart-drawer');
        var sections = [];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          try { sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).filter(Boolean); } catch (e) {}
        }
        var payload = { items: [{ id: variantId, quantity: 1 }] };
        if (sections.length) { payload.sections = sections; payload.sections_url = window.location.pathname; }

        var wasOpen = cartDrawer && (cartDrawer.classList.contains('active') || cartDrawer.hasAttribute('open'));
        if (wasOpen) setCartLoading(true);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); }).then(function (state) {
          if (wasOpen && cartDrawer && typeof cartDrawer.renderContents === 'function' && state.sections) {
            cartDrawer.renderContents(state);
          }
        }).finally(function () { if (wasOpen) schedule(); });
      });
  }

  (function () {
    var target = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(function () { runPreSelectFix(); }).observe(target, { childList: true, subtree: true });
    runPreSelectFix();
  })();
})();
